// Réglage « Mode mobile » : automatique, ou forcé quand la détection se trompe.
import { detectMobile, setDeviceSetting, useDeviceSetting, type DeviceSetting } from './device';

const CHOICES: { value: DeviceSetting; label: string }[] = [
  { value: 'auto', label: 'Automatique' },
  { value: 'mobile', label: 'Activé' },
  { value: 'desktop', label: 'Désactivé' },
];

export function DeviceSettingPicker() {
  const setting = useDeviceSetting();
  return (
    <div className="device-setting">
      <div className="device-setting-label">
        <strong>Mode mobile</strong>
        <span>
          Les outils de terrain (photo, vidéo, enregistrement). Détecté sur cet appareil :{' '}
          {detectMobile() ? 'téléphone ou tablette' : 'ordinateur'}.
        </span>
      </div>
      <div className="zy-segmented" role="group" aria-label="Mode mobile">
        {CHOICES.map((c) => (
          <button
            key={c.value}
            type="button"
            aria-pressed={setting === c.value}
            onClick={() => setDeviceSetting(c.value)}
          >
            {c.label}
          </button>
        ))}
      </div>
    </div>
  );
}
